export const Templates = {
    MAIN: 1,
    ABILITIES: 2,
    BOT: 3,
    DEMO: 4,
    BLOG: 5,
    PRIVACY: 6,
    AGREEMENT: 7,
    EXPENSES: 8,
    MAINTENANCE: 9,
    PLAN: 10,
    FUEL: 11,
    MILEAGE: 12,
    TRIP_CALCULATOR: 13,
    SERVICE_PROVIDERS: 14,
    NOTES: 15,
    TOOLS: 16,
    ROUTE_DISTANCE: 17,
};

export interface TemplateSchema {
    name: string;
    page: {
        h1: string;
        breadcrumb: string;
        title: string;
        og_title: string;
        description: string;
        og_description: string;
        keywords: string;
        indexed?: boolean;
    };
}

export class Template {
    private _data: TemplateSchema | undefined;

    constructor(data: TemplateSchema) {
        if (data) {
            this.data = data;
        }
    }

    get data(): TemplateSchema {
        return this._data as TemplateSchema;
    }

    set data(value: TemplateSchema) {
        this._data = value;
    }
}
